import React, { useState } from "react";
import "../../styles/contact.css";
import { Helmet } from "react-helmet-async";
import { FiPhone } from "react-icons/fi";
import { FiMapPin } from "react-icons/fi";
import { FiMail } from "react-icons/fi";

// ✅ Use your actual Google Form formResponse URL here
// const GOOGLE_FORM_URL =
//   "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfhMsviOEYaebVO3pyMxM6zJj_BQiD0rOove6jwUXtVOOi1JA/formResponse";

const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfhMsviOEYaebVO3pyMxM6zJj_BQiD0rOove6jwUXtVOOi1JA/formResponse";


export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    organization: "",
    inquiryType: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const inquiryTypeMapping = {
  general: "General Information",
  enrollment: "Course Enrollment",
  partnership: "Partnership Enquiry",
  csr: "CSR Funding",
  other: "Other",
};

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formEntries = new URLSearchParams();

    // formEntries.append("entry.854248741", formData.name);
    // formEntries.append("entry.193980692", formData.email);
    // formEntries.append("entry.525348159", formData.organization);
    // formEntries.append("entry.1847721547", formData.inquiryType);
    // formEntries.append("entry.2047635273", formData.subject);
    // formEntries.append("entry.273577498", formData.message);



      formEntries.append("entry.1346145008", formData.name);          // Full Name
      formEntries.append("entry.983364078", formData.email);         // Email
      formEntries.append("entry.838784458", formData.phone);         // Contact Number
      formEntries.append("entry.736121350", formData.organization);  // Organization
      // formEntries.append("entry.1324814405", formData.inquiryType); 
      formEntries.append(
  "entry.1324814405",
  inquiryTypeMapping[formData.inquiryType] || ""
);  
      formEntries.append("entry.1371571333", formData.subject);       // Subject
      formEntries.append("entry.595529685", formData.message);   

      // Optional extras some forms accept
      formEntries.append("submit", "Submit");


      console.log(formEntries.toString());

      await fetch(GOOGLE_FORM_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formEntries.toString(),
      });

      // On success (no network error) → show modal + clear form
      setIsSubmitted(true);
      setFormData({
        name: "",
        email: "",
        phone:"",
        organization: "",
        inquiryType: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error("Error submitting form:", err);
      alert(
        "There was an error submitting the form. Please email us at contact@pracverse.com."
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
    <Helmet>
  <title>Contact PracVerse – Drone Courses, Partnerships & CSR Programs</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Get in touch with PracVerse to schedule a drone education demo, discuss school partnerships, CSR initiatives or STEM programs."
  />
  <link rel="canonical" href="https://www.pracverse.com/contact" />

  <meta property="og:title" content="Contact PracVerse – Drone Education & Partnerships" />
  <meta
    property="og:description"
    content="Reach out for drone courses, workshops, school programs and CSR-based education initiatives."
  />
  <meta property="og:url" content="https://www.pracverse.com/contact" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-contact.jpg" />

  {/* Contact Page + FAQ schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact PracVerse",
      "url": "https://www.pracverse.com/contact",
      "mainEntity": {
        "@type": "Organization",
        "name": "PracVerse"
      }
    })}
  </script>

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How do I enroll my school in your programs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":
              "Contact us through the form on this page or email contact@pracverse.com. We will understand your requirements and design a customized program for your institution."
          }
        },
        {
          "@type": "Question",
          "name": "What age groups do your courses target?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":
              "Our programs are designed for students aged 8–18, with age-appropriate curricula for primary, middle and senior school, along with teacher training."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide equipment and materials?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":
              "Yes. We provide drones, programming tools and learning material. Equipment can be purchased or structured into the partnership model."
          }
        }
      ]
    })}
  </script>
</Helmet>

    <div className="contact-page ">
      {/* CONTACT HERO */}
      <section className="contact-hero-section">
        <div className="container contact-hero-inner">
          <h1 className="contact-hero-title">Get in Touch</h1>

          <p className="contact-hero-sub">
            Ready to transform education with drone technology? We'd love to hear
            from you. Whether you're an educator, institution, or organization,
            let's explore how we can work together.
          </p>
        </div>
      </section>

      {/* SEND US A MESSAGE + CONTACT INFO (two-column layout) */}
      <section className="contact-main-section">
        <div className="container contact-main-grid">
          {/* LEFT: Form Card */}
          <div className="contact-form-card">
            <h2 className="contact-form-title">Send Us a Message</h2>
            <p className="contact-form-sub">
              Fill out the form below and we'll get back to you as soon as
              possible.
            </p>

            <form
              className="contact-form"
              onSubmit={handleSubmit}
              aria-label="Contact form"
            >
              {/* <div className="form-row two-cols">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Enter your full name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Enter your email address"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div> */}



              <div className="form-row two-cols">
  <div className="form-group">
    <label htmlFor="name">Full Name *</label>
    <input
      id="name"
      name="name"
      type="text"
      placeholder="Enter your full name"
      required
      value={formData.name}
      onChange={handleChange}
    />
  </div>

  <div className="form-group">
    <label htmlFor="phone">Contact Number *</label>
    <input
      id="phone"
      name="phone"
      type="tel"
      placeholder="Enter your contact number"
      required
      value={formData.phone}
      onChange={handleChange}
    />
  </div>
</div>




              <div className="form-row two-cols">
                <div className="form-group">
                  <label htmlFor="organization">Organization</label>
                  <input
                    id="organization"
                    name="organization"
                    type="text"
                    placeholder="School, college, company, etc."
                    value={formData.organization}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

                
              </div>
              <div className="form-group" style={{ paddingBottom: "10px" }}>
                  <label htmlFor="inquiryType">Inquiry Type *</label>
                  <select
                    id="inquiryType"
                    name="inquiryType"
                    required
                    value={formData.inquiryType}
                    onChange={handleChange}
                    
                  >
                    <option value="">Select inquiry type</option>
                    <option value="general">General Information</option>
                    <option value="enrollment">Course Enrollment</option>
                    <option value="partnership">Partnership Enquiry</option>
                    <option value="csr">CSR Funding</option>
                    <option value="other">Other</option>
                  </select>


                  

                </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    id="subject"
                    name="subject"
                    type="text"
                    placeholder="Brief description of your inquiry"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    placeholder="Please provide details about your inquiry, including any specific requirements or questions you may have."
                    value={formData.message}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <button
                  type="submit"
                  className="btn send-message-btn"
                  aria-label="Send message"
                  disabled={isSubmitting}
                >
                  <span className="send-icon" aria-hidden="true">
                    ✈
                  </span>
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>

          {/* RIGHT: Contact Information Cards */}
          <aside
            className="contact-info-col"
            aria-labelledby="contact-info-heading"
          >
            <h3 id="contact-info-heading" className="contact-info-heading">
              Contact Information
            </h3>

            <div className="contact-cards">
              {/* EMAIL */}
              <div className="contact-card">
                <div className="card-icon">
                  {/* <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 8.5v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                      stroke="#6B62A7"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 8.5L12 13l9-4.5"
                      stroke="#6B62A7"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> */}
                  <span className="contact-icon" style={{ color: "#6B62A7" }}><FiMail /></span>
                </div>
                <div className="card-body">
                  <h4>Email Us</h4>
                  <a href="mailto:contact@pracverse.com" className="card-lines">contact@pracverse.com</a>
                  <small>
                    Send us an email for general inquiries or partnership
                    opportunities
                  </small>
                </div>
              </div>

              {/* CALL */}
              <div className="contact-card">
                <div className="card-icon">
                  {/* <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M22 16.92V21a1 1 0 0 1-1.11 1A19 19 0 0 1 3 5.11 1 1 0 0 1 4 4h4.09a1 1 0 0 1 1 .75c.12.66.38 1.95.83 3.39a1 1 0 0 1-.24 1.02L8.91 11.91a16 16 0 0 0 4.19 4.19l1.75-1.75a1 1 0 0 1 1.02-.24c1.44.45 2.73.71 3.39.83a1 1 0 0 1 .75 1V21"
                      stroke="#6B62A7"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> */}
                  <span className="contact-icon" style={{ color: "#6B62A7" }}><FiPhone /></span>
                </div>
                <div className="card-body">
                  <h4>Call Us or WhatsApp</h4>
                  <p className="card-lines">
                    +91 7738700773
                    <br />
                    +91 9004802817
                  </p>
                  <small>
                    Speak directly with our team during business hours
                  </small>
                </div>
              </div>

              {/* QUICK RESPONSE */}
              <div className="contact-card dark">
                <div className="card-icon light">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="#1f2340"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="card-body">
                  <h4>Quick Response Guarantee</h4>
                  <p className="card-lines">
                    We respond to all inquiries within 24 hours during business
                    days. Urgent matters are handled immediately.
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </section>

      {/* FAQ SECTION (unchanged) */}
      <section id="faq" className="faq-section">
        <div className="container">
          <header
            className="faq-header"
            style={{ textAlign: "center", marginBottom: 28 }}
          >
            <h2>Frequently Asked Questions</h2>
            <p className="faq-sub">
              Quick answers to common questions. Can't find what you're looking
              for? Contact us directly.
            </p>
          </header>

          <div className="faq-grid">
            <div className="faq-col">
              <div className="faq-item">
                <h4 className="faq-q">
                  How do I enroll my school in your programs?
                </h4>
                <p className="faq-a">
                  You may reach out through the form above or write to us at contact@pracverse.com. Our team will connect with you to understand your school’s requirements and recommend the most suitable program structure.
                </p>
              </div>

              <div className="faq-item">
                <h4 className="faq-q">
                  How does CSR funding work?
                </h4>
                <p className="faq-a">
                  We support organizations in executing education-focused CSR initiatives end-to-end — including program planning, documentation, compliance, and impact reporting — ensuring the activity delivers measurable value to learners and partners.
                </p>
              </div>

              <div className="faq-item">
                <h4 className="faq-q">What age groups do your courses target?</h4>
                <p className="faq-a">
                  Our curriculum is thoughtfully designed for learners aged 8–18, with structured pathways for primary, middle, and senior school students to ensure age-appropriate, progressive learning.
                </p>
              </div>
            </div>

            <div className="faq-col">
              <div className="faq-item">
                <h4 className="faq-q">Can the program be customized for our school’s needs?</h4>
                <p className="faq-a">
                  Absolutely. Schools can choose from multiple formats — workshops, short-term modules, or full-term programs — depending on their academic schedule, student interest, and infrastructure.
                </p>
              </div>

              <div className="faq-item">
                <h4 className="faq-q">Do you provide equipment and materials?</h4>
                <p className="faq-a">
                  Yes. All drones, learning kits, software, and teaching materials required for the sessions are provided by PracVerse. Depending on your preference, equipment can be leased or purchased.
                </p>
              </div>

              <div className="faq-item">
                <h4 className="faq-q">Can individual students enroll in courses?</h4>
                <p className="faq-a">
                  At present, our offerings are delivered through schools and institutions. Individual enrolment pathways are under development — you may contact us to stay updated on upcoming batches.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Success Modal */}
      {isSubmitted && (
        <>
          <div className="contact-modal-overlay" />
          <div className="contact-modal">
            <button
              className="contact-modal-close"
              onClick={() => setIsSubmitted(false)}
            >
              ×
            </button>
            <h2>Form Submitted Successfully!</h2>
            <p>Thank you! Our team will contact you within 24 hours.</p>
            <button
              className="contact-modal-ok"
              onClick={() => setIsSubmitted(false)}
            >
              OK
            </button>
          </div>
        </>
      )}
    </div>
    </>
  );
}
